<div class="container">
    <div class="row">
        <div class="col-12">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="goback()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Home-Connect Application Form
            </span>
        </div>
    </div>
    <div class="card card_content">

        <!-- <div class="cssmtgb just_center">
            <mat-tab-group animationDuration="1000ms" mat-stretch-tabs mat-align-tabs="start"
                (selectedTabChange)="onTabChange($event)">
                <mat-tab label="Application Details"> -->
        <div class="container">

            <div class="row d-flex align-items-center flex-wrap grid-margin mb-2" style="position: sticky; top: 0;
            z-index: 10;" *ngIf="value.title != 'editapplication'&&value.title != 'fibereditapplication'">
                <div class="col-xl-6 mb-2">
                    <button style="font-size: 14pt" class="btn btn-primary hoverconnection pl-2"
                        (click)="viewproduct()">
                        <img src="assets/Home-Connect/images/tap.svg" class="mr-2 connection_icon jello_vertical"
                            alt="" />
                        <span>View chosen products</span>

                    </button>
                </div>
                <ng-container
                    *ngIf="(sessionDataString.roletype==roleType.Admin || sessionDataString.roletype==roleType.SuperAdmin || sessionDataString.roleId == roleType.Sales) &&(isView!=1)">
                    <div class="col-md-6 d-flex gap-2 flex-wrap">
                        <div style="padding-left:8rem" *ngIf="(value.title == 'transfer' || value.title == 'fiber' || value.title == 'wirelessrain')
                                && (
                                application?.applicationStatus == applicationstatus.Submitted ||
                                application?.applicationStatus == applicationstatus.Resubmitted ||
                                application?.applicationStatus == applicationstatus.VumatelOrderCancelledbyHomeConnect ||
                                application?.applicationStatus == applicationstatus.NetworkNotReady ||
                                application?.applicationStatus == applicationstatus.Rejected)">

                            <!-- ||application?.applicationStatus == applicationstatus.EFTPaymentSuccessful -->
                            <button type="button" class="btn btn-secondary mr-2"
                                (click)="save(applicationstatus.Approved, application.serviceProviderId, application.id)">
                                Approve
                            </button>
                        </div>
                        <div style="padding-left:18rem" *ngIf="(value.title == 'wirelessrain')
                             && (application?.applicationStatus == applicationstatus.Pending)">

                            <button type="button" class="btn btn-secondary mr-2"
                                (click)="moveToNewApplication(application.id)">
                                Move To New Application
                            </button>
                        </div>
                        <div *ngIf="(value.title == 'transfer' || value.title == 'fiber' || value.title == 'wirelessrain')
                     && (
                    application?.applicationStatus == applicationstatus.Submitted ||
                    application?.applicationStatus == applicationstatus.Resubmitted ||
                    application?.applicationStatus == applicationstatus.VumatelOrderCancelledbyHomeConnect ||
                    application?.applicationStatus == applicationstatus.NetworkNotReady ||
                    application?.applicationStatus == applicationstatus.Rejected ||
                    application?.applicationStatus == applicationstatus.NewTransfer)">
                            <!-- ||application?.applicationStatus == applicationstatus.EFTPaymentSuccessful)"> -->

                            <button type="button" class="btn reset_btn text-nowrap mr-2"
                                *ngIf="application?.applicationStatus != applicationstatus.Rejected"
                                (click)="save(applicationstatus.Rejected,application.serviceProviderId)">
                                Reject/Incomplete
                            </button>
                            <button type="button" class="btn btn-primary text-nowrap"
                                *ngIf="application?.applicationStatus != applicationstatus.Rejected"
                                (click)="save(applicationstatus.Cancelled)">
                                cancel
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="scroll">
                <form [formGroup]="form">
                    <ng-container *ngIf="showproduct">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-12 ">
                                        <span class="title_header_bar">Product Details</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card card_content mb-3">
                            <div class="table-responsive mt-2 mb-4">
                                <mat-table #table [dataSource]="dataSource4">

                                    <ng-container matColumnDef="ServiceProviderName">
                                        <mat-header-cell *matHeaderCellDef>Service Provider Name</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign"> {{dataField.serviceProvider}}</p>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="ProductId">
                                        <mat-header-cell *matHeaderCellDef>Product Id</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">{{dataField.productId}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="ProductName">
                                        <mat-header-cell *matHeaderCellDef> Product Name</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">{{dataField.aliasName}} </p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="Cost">
                                        <mat-header-cell *matHeaderCellDef
                                            [hidden]="sessionDataString.roletype == roleType.Technician">Cost</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField"
                                            [hidden]="sessionDataString.roletype == roleType.Technician">
                                            <p class="text-truncate txtalign">R
                                                {{dataField.totalProductCost.toFixed(2)}}
                                            </p>
                                        </mat-cell>
                                    </ng-container>


                                    <mat-header-row *matHeaderRowDef="displayedColumns4; sticky:true"></mat-header-row>

                                    <mat-row *matRowDef="let row; columns: displayedColumns4;" matRipple>
                                    </mat-row>

                                </mat-table>
                            </div>
                        </div>
                    </ng-container>






                    <div class="row">
                        <div class="col-12 ">
                            <div class="title_header_bar2">
                                <span
                                    *ngIf="value.title!='transfer' && value.title!='fiber' && value.title != 'editapplication'&& value.title != 'fibereditapplication' && this.value.title != 'wirelessrain'&& value.title!='view'&& value.title!='viewfiber' "
                                    style="margin-right: 48rem;">Details - #
                                    {{details?.referenceNumber}}</span>
                                <span
                                    *ngIf="value.title=='transfer' || value.title=='fiber' || value.title == 'editapplication' || value.title == 'fibereditapplication'|| this.value.title == 'wirelessrain' ||value.title=='view' || value.title=='viewfiber'"
                                    style="margin-right: 48rem;">Details - #
                                    {{applicationDetails?.referenceNumber}}</span>
                            </div>

                        </div>
                    </div>
                    <div class="card card_content">

                        <div class="row "
                            *ngIf="dataSource1.changeRequestStatus== applicationstatus.Cancelled && details.reason">
                            <div class="col-md-12">
                                <div class="col-md-12" style="font-size:large;color:#e6831a">
                                    <i class="fa fa-exclamation-triangle " aria-hidden="true">

                                    </i>
                                    <span> Cancelled Reason:{{details.reason}}</span>

                                </div>
                                <div class="col-md-12" style="color:#ec561a">
                                    <span> Cancelled Time:{{details.lastChangeTs | date:'dd MMM yyyyHH:mm'}}</span>,
                                    <span> Cancelled By:{{details.lastchangeUserName}}</span>
                                </div>

                            </div>
                        </div>
                        <div class="row mx-5"
                            *ngIf="value.title=='editapplication'|| value.title=='fibereditapplication'">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Customer Number</mat-label>
                                    <input matInput maxlength="15" formControlName="customerNumber" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4" *ngIf="form.value.resellerName">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Reseller Name</mat-label>
                                    <input matInput appInputtext formControlName="resellerName" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-5">
                            <!-- <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Title</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="title"
                                        placeholder="Select Complex / Estate ">
                                        <mat-select-filter [displayMember]="'value'" [array]="titlelist"
                                            (filteredReturn)="filteredList = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredList" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div> -->
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>First Name</mat-label>
                                    <input matInput appInputtext formControlName="firstName" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Last Name</mat-label>
                                    <input matInput appInputtext formControlName="lastName" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row mx-5">

                            <!-- <div class="col-sm-12 col-md-6 mt-4">
                                <div class="col-sm-12 col-md-12 align-self-center"
                                    style="display: flex; align-items: center;">
                                    <label style="margin-right: 30px; font-size: large;">Gender</label>
                                    <mat-radio-group formControlName="gender"
                                        style="display: flex; flex-direction: row mx-5; gap: 80px;">
                                        <mat-radio-button value="1">Male</mat-radio-button>
                                        <mat-radio-button class="ml-3" value="2">Female</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div> -->
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>ID/Passport No</mat-label>
                                    <input matInput maxlength="25" formControlName="identificationNumber" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-xl-6 mt-4">
                                <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                    <mat-label>DOB</mat-label>
                                    <input readonly matInput [matDatepicker]="startDatePicker"
                                        formControlName="dateOfBirth" autocomplete="off" placeholder="Select From Date"
                                        class="custom-input-border" (click)="startDatePicker.open()">
                                    <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                        <button mat-icon-button>
                                            <mat-icon>event</mat-icon>
                                        </button>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #startDatePicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- <div class="row mx-5">


                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Home Language</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="homeLanguage"
                                        placeholder="Select Complex / Estate ">
                                        <mat-select-filter [displayMember]="'value'" [array]="languagelist"
                                            (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div> -->
                        <div class="row mx-5">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Address Line1</mat-label>
                                    <input matInput formControlName="addressLine1" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Primary Contact No</mat-label>
                                    <input matInput maxlength="15" formControlName="primaryContactNumber" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row mx-5">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Address Line2</mat-label>
                                    <input matInput formControlName="addressLine2" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Land Line No</mat-label>
                                    <input matInput maxlength="15" formControlName="landLineNumber" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row mx-5">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Suburb</mat-label>
                                    <input matInput formControlName="suburb" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Mobile No</mat-label>
                                    <input matInput maxlength="15" formControlName="mobileNumber" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row mx-5">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>City</mat-label>
                                    <input matInput appInputtext maxlength="25" formControlName="city" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email" class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>

                        </div>
                        <div class="row mx-5">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Region</mat-label>
                                    <input matInput appInputtext maxlength="25" formControlName="region" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Latitude</mat-label>
                                    <input matInput maxlength="25" formControlName="latitude" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-5">


                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Country</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="country"
                                        placeholder="Select Complex / Estate ">
                                        <mat-select-filter [displayMember]="'value'" [array]="countrylist"
                                            (filteredReturn)="filteredList2 = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredList2" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Longitude</mat-label>
                                    <input matInput maxlength="25" formControlName="longitude" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-5">
                            <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Area code</mat-label>
                                    <input matInput maxlength="25" formControlName="pinCode" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>

                        </div>
                        <div class="row mx-5">
                            <div class="col-sm-12 col-md-6 mt-5">
                                <div class="col-sm-12 col-md-12 align-self-center"
                                    style="display: flex; align-items: center;">
                                    <label style="margin-right: 30px; font-size: large;">Ownership</label>
                                    <mat-radio-group formControlName="ownerShip"
                                        style="display: flex; flex-direction: row mx-5; gap: 80px;">
                                        <mat-radio-button class="pr-3" value="1">Owner</mat-radio-button>
                                        <mat-radio-button value="2">Tenant</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4" *ngIf="isTenent">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Landlord's Name</mat-label>
                                    <input matInput appInputtext formControlName="legalOwnerName" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-5">
                            <div class="col-sm-12 col-md-6 mt-4" *ngIf="isTenent">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Landlord's No</mat-label>
                                    <input matInput maxlength="15" formControlName="legalOwnerContactNumber"
                                        class="col-10" autocomplete="off">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-5" *ngIf="isvoice">
                            <div class="col-sm-12 col-md-12 mt-5">
                                <div class="col-sm-12 col-md-12 align-self-center"
                                    style="display: flex; align-items: center;">
                                    <label style="margin-right: 30px; font-size: large;">Voice Type</label>
                                    <mat-radio-group formControlName="voiceType"
                                        style="display: flex; flex-direction: row mx-5; gap: 80px;">
                                        <mat-radio-button class="pr-3" value="1">Voice Number
                                            Required</mat-radio-button>
                                        <mat-radio-button value="2">Porting Required</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>

                        </div>
                        <div class="row mx-5 mt-4"
                            *ngIf="value.title=='editapplication'||value.title=='fibereditapplication'">
                            <div class="col-md-6">
                                <mat-form-field appearance="fill" style="width: 100%;" hideRequiredMarker>
                                    <mat-label>Product</mat-label>
                                    <mat-select placeholder="Select Primary Product" formControlName="productId">
                                        <input matInput placeholder="Search" />
                                        <mat-optgroup *ngFor="let group of filteredGroupedProducts()"
                                            [label]="group?.categoryName?.toUpperCase()">
                                            <mat-option *ngFor="let product of group.products" [value]="product.id"
                                                (onSelectionChange)="onProductSelected($event, product, group)">
                                                {{ product?.aliasName?.toUpperCase() }} - {{
                                                product?.productCategoryName?.toUpperCase() }}
                                            </mat-option>
                                        </mat-optgroup>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-12 col-md-6" *ngIf="labelShow">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Changed Product</mat-label>
                                    <input matInput [value]="productName" class="col-10" autocomplete="off" readonly>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-5"
                            *ngIf="value.title=='editapplication'||value.title=='fibereditapplication'">

                            <!-- <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Reseller Code</mat-label>
                                    <input matInput maxlength="25" formControlName="resellerCode" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div> -->

                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Reseller Code</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="resellerCode"
                                        placeholder="Select Reseller Code" [disabled]="form.value.salesRepCode">
                                        <mat-select-filter [displayMember]="'resellerCode'" [array]="resellerOptions"
                                            (filteredReturn)="filteredList5 = $event">
                                        </mat-select-filter>
                                        <mat-option [value]="">Select Reseller Code</mat-option>
                                        <mat-option *ngFor="let item of filteredList5" [value]="item.resellerCode"
                                            style="overflow-y: scroll !important;">
                                            {{item.resellerCode}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>


                            <div class="col-xl-6 mt-4"
                                *ngIf="form.value.resellerCode && resellerSalesPersonList?.length > 0">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Reseller Sales Person</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="resellerSalesPerson"
                                        placeholder="Select Reseller Sales Person">
                                        <mat-option *ngFor="let item of resellerSalesPersonList"
                                            [value]="item.resellerSalesCode.toUpperCase()">
                                            {{item.resellerSalesCode}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="form.get('resellerSalesPerson')?.hasError('required') && (form.get('resellerSalesPerson')?.dirty || form.get('resellerSalesPerson')?.touched)">
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Sales Rep Code</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="salesRepCode"
                                        placeholder="Select Sales Rep Code" [disabled]="isSalesRepDisabled()">

                                        <mat-select-filter [displayMember]="'value'" [array]="salesrepList"
                                            (filteredReturn)="filteredList4 = $event"></mat-select-filter>
                                        <mat-option [value]="">Select Salesrep Code</mat-option>
                                        <mat-option *ngFor="let item of filteredList4" [value]="item.value"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-12 mt-3" style="color: red;">
                                Note : Either Reseller Code or Sales Rep Code can be filled at a time*
                            </div>

                            <!-- <div class="col-sm-12 col-md-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Sales Rep Code</mat-label>
                                    <input matInput maxlength="25" formControlName="salesRepCode" class="col-10"
                                        autocomplete="off">
                                </mat-form-field>
                            </div> -->
                        </div>
                        <div class="row mx-5"
                            *ngIf="value.title=='editapplication'||value.title=='fibereditapplication'">

                            <div class="col-sm-12 col-md-6 mt-4" *ngIf="PromocodeList && PromocodeList.length > 0">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Promo Code</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="promoCode"
                                        placeholder="Select Promo Code" (selectionChange)="onPromoChange()"
                                        [disabled]="isPromoDisabled()">
                                        <mat-select-filter [displayMember]="'value'" [array]="PromocodeList"
                                            (filteredReturn)="filteredList6 = $event"></mat-select-filter>
                                        <mat-option [value]="">Select Promo Code</mat-option>
                                        <mat-option *ngFor="let item of filteredList6" [value]="item.value"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <!-- <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Promo Code</mat-label>
                                    <input matInput maxlength="25" formControlName="promoCode" class="col-10"
                                        autocomplete="off" (input)="convertToUpperCase($event)">
                                </mat-form-field> -->
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4"
                                *ngIf="editduration && form.value.promoCode !=null && form.value.promoCode != '' ">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Duration</mat-label>
                                    <input type="number" matInput maxlength="2" formControlName="duration"
                                        class="col-10" autocomplete="off" (input)="onDurationInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mx-5"
                            *ngIf="value.title=='editapplication'||value.title=='fibereditapplication'">
                            <div class="col-sm-12 col-md-12 mt-4"
                                *ngIf="isNotRecurringDate && isRetentionPromoApplicable && isEmailAllowed">
                                <div class="col-12" style="margin-left:-10px">
                                    <mat-checkbox style="transform: scale(1.3);" color="primary"
                                        [checked]="isPromotionChecked"
                                        (change)="promotionChange($event)"></mat-checkbox>
                                    <label style="margin-left: 20px; font-size: large; white-space: nowrap;">
                                        Would you like to apply Retention Promotion?
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mx-5">
                            <div class="col-sm-12 col-md-6 mt-4" *ngIf="isPromotionChecked">
                                <!-- <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Retention Promo Code</mat-label>
                                    <input matInput appAlphaNumeric type="text" id="promo"
                                        formControlName="retentionPromoCode" autocomplete="off" class="col-12">
                                </mat-form-field> -->
                                <!-- <div class="col-12" *ngIf="isPromotionChecked"> -->
                                <mat-form-field appearance="fill" hideRequiredMarker style="width: 100%;">
                                    <mat-label>Retention Promo Code</mat-label>
                                    <mat-select formControlName="retentionPromoCode"
                                        placeholder="Select Retention Promo Code"
                                        (selectionChange)="onRetentionPromoCodeSelected($event)">
                                        <mat-select-filter [array]="retentionPromoList"
                                            (filteredReturn)="retentionPromoList = $event">
                                        </mat-select-filter>
                                        <mat-option *ngFor="let promo of retentionPromoList" [value]="promo">
                                            {{ promo }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <!-- </div> -->
                            </div>
                            <div class="col-sm-12 col-md-6 mt-4" *ngIf="isPromotionChecked">
                            </div>
                        </div>
                        <div class="row mx-5">
                            <div class="col-sm-12 col-md-6 mt-4" *ngIf="isRetentionPromoSelected">
                                <div class="promo-card">
                                    <div class="price-row">
                                        <span>Current Product Price (R)</span>
                                        <span>{{matchedRetentionPromo.originalPriceIncVat}}</span>
                                    </div>
                                    <div class="price-row">
                                        <span>Discounted Product Price(R)</span>
                                        <span>{{-matchedRetentionPromo.discountedPriceIncVat}}</span>
                                    </div>
                                    <!-- <div class="price-row">
                                        <span>VAT Amount</span>
                                        <span>{{-retentionPromoDetails.discountedPriceVatAmount}}</span>
                                    </div> -->

                                    <mat-divider style="border-top-color: blueviolet;"></mat-divider>

                                    <div class="price-row">
                                        <strong>Total (R)</strong>
                                        <strong>{{matchedRetentionPromo.savingsAmount}}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div calss="row ml-5"
                            *ngIf="value.title=='editapplication'||value.title=='fibereditapplication'">
                            <div class="col-sm-6 col-sx-6 col-md-6 mt-4 ml-5 form-radio-group">
                                <mat-radio-group formControlName="complex">
                                    <mat-label>Is it MDU</mat-label>
                                    <mat-radio-button class="ml-3" value='1'>Yes</mat-radio-button>&nbsp;&nbsp;&nbsp;
                                    <mat-radio-button value='0'>No</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>
                        <ng-container *ngIf="isComplex">
                            <div class="row mx-5">
                                <div class="col-sm-12 col-md-6">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Complex/Estate Name</mat-label>
                                        <input matInput formControlName="complexName" placeholder="Enter first name"
                                            class="col-12" autocomplete="off">
                                    </mat-form-field>
                                    <mat-error *ngIf="form.get('complexName').invalid &&
                        (form.get('complexName').dirty || form.get('complexName').touched)">
                                        Please enter complex name
                                    </mat-error>
                                </div>

                                <div class="col-sm-12 col-md-6">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Unit Stand Number</mat-label>
                                        <input matInput formControlName="complexUnitNo" placeholder="Enter first name"
                                            class="col-12" autocomplete="off" maxlength="5">
                                    </mat-form-field>
                                    <mat-error *ngIf="form.get('complexUnitNo').invalid &&
                            (form.get('complexUnitNo').dirty || form.get('complexUnitNo').touched)">
                                        Please enter unite stand number
                                    </mat-error>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="showAdditionalQuestions">
                            <div class="row mx-5">
                                <div class="col-xl-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Name Of ISP</mat-label>
                                        <mat-select class="scrollbarcs" formControlName="isP_Id"
                                            placeholder="Please Enter Valid ISP" (selectionChange)="ispNameOnChange()">
                                            <mat-select-filter [displayMember]="'value'" [array]="ispNameList"
                                                (filteredReturn)="ispNameList = $event"></mat-select-filter>
                                            <mat-option *ngFor="let item of ispNameList" [value]="item.key"
                                                style="overflow-y: scroll !important;">
                                                {{item.value}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 mt-4" *ngIf="showCurrentISPName">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Current ISP Name</mat-label>
                                        <input matInput maxlength="25" formControlName="currentISPName" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row mx-5">

                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Current ISP Reference Number</mat-label>
                                        <input matInput maxlength="25" formControlName="currentISPNumber" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row mx-5">
                                <div class="col-xl-6 mt-4">
                                    <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                        <mat-label>Cancellation date with current ISP</mat-label>
                                        <input readonly matInput [matDatepicker]="cancelDatePicker"
                                            formControlName="cancellationDate" autocomplete="off"
                                            placeholder="Select From Date" class="custom-input-border"
                                            (click)="cancelDatePicker.open()">
                                        <mat-datepicker-toggle matSuffix [for]="cancelDatePicker" style="color:black;">
                                            <button mat-icon-button>
                                                <mat-icon>event</mat-icon>
                                            </button>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #cancelDatePicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-xl-6 mt-4">
                                    <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                        <mat-label>Required Home-Connect activation Date</mat-label>
                                        <input readonly matInput [matDatepicker]="activationDatePicker"
                                            formControlName="requiredServicesOn" autocomplete="off"
                                            placeholder="Select From Date" class="custom-input-border"
                                            (click)="activationDatePicker.open()">
                                        <mat-datepicker-toggle matSuffix [for]="activationDatePicker"
                                            style="color:black;">
                                            <button mat-icon-button>
                                                <mat-icon>event</mat-icon>
                                            </button>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #activationDatePicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </ng-container>

                        <div class="col-md-12 d-flex justify-content-end mt-3"
                            *ngIf="value.title=='editapplication'||value.title=='fibereditapplication'">
                            <button type="button" class="btn btn-secondary mr-2" (click)="updateeditApplication()">
                                Submit
                            </button>
                            <button type="button" class="btn btn-primary text-nowrap" (click)="goback()">
                                cancel
                            </button>
                        </div>
                    </div>
                </form>
                <!-- </mat-tab> -->
                <div class="container my-4"
                    *ngIf="(value.title=='cancel'||value.title=='transfer' || value.title=='fiber' || value.title == 'wirelessrain'|| value.title == 'view' ||value.title == 'viewfiber' ) && dataSource3.data.length>0">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Additional Questions</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <!-- <mat-tab label="Additional Questions"> -->
                        <div class="container">
                            <!-- <div class="card mt-4">
                        <div class="card-body p-0">
                            <div class="form-body" style="font-size: large;">
                                <div class="row">
                                    <div class="col-6 p-3">Is ONT on Site?</div>
                                    <div class="col-6 p-3">
                                        {{ additionalQuestions?.isONT === true ? "Yes" : "No" }}
                                    </div>

                                    <div class="col-6 p-3">Currently with ISP?</div>
                                    <div class="col-6 p-3">
                                        {{ additionalQuestions?.isISP === true ? "Yes" : "No" }}
                                    </div>

                                    <div class="col-6 p-3">Make of ONT</div>
                                    <div class="col-6 p-3">
                                        {{
                                        additionalQuestions?.makeOfONT === null
                                        ? "-"
                                        : additionalQuestions?.makeOfONT
                                        }}
                                    </div>

                                    <div class="col-6 p-3">FSAN/Device SL NO</div>
                                    <div class="col-6 p-3">
                                        {{
                                        additionalQuestions?.fsanDeviceSerialNo === null
                                        ? "-"
                                        : additionalQuestions?.fsanDeviceSerialNo
                                        }}
                                    </div>

                                    <div class="col-6 p-3">Cancellation Date</div>
                                    <div class="col-6 p-3">
                                        {{
                                        additionalQuestions?.cancellationDate === null
                                        ? "-"
                                        : (additionalQuestions?.cancellationDate
                                        | date : "dd-MMM-yyyy")
                                        }}
                                    </div>

                                    <div class="col-6 p-3">Required Services On</div>
                                    <div class="col-6 p-3">
                                        {{
                                        additionalQuestions?.requiredServicesOn === null
                                        ? "-"
                                        : (additionalQuestions?.requiredServicesOn
                                        | date : "dd-MMM-yyyy")
                                        }}
                                    </div>

                                    <div class="col-6 p-3" *ngIf="isbNumber">B Number</div>
                                    <div class="col-6 p-3" *ngIf="isbNumber">
                                        {{ additionalQuestions?.bNumber ? additionalQuestions?.bNumber:"-" }}
                                    </div>

                                    <div class="col-6 p-3">Comments</div>
                                    <div class="col-6 p-3">
                                        {{ additionalQuestions?.comments ? additionalQuestions?.comments:"-" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

                            <div class="table-responsive mt-4 mb-4">
                                <mat-table #table [dataSource]="dataSource3" matSort matSortDirection="asc">

                                    <ng-container matColumnDef="IsONT">
                                        <mat-header-cell *matHeaderCellDef>Is ONT on Site?</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign"> {{dataField.isONT === true ? "Yes" :
                                                "No"}}
                                            </p>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="ISP">
                                        <mat-header-cell *matHeaderCellDef>Currently with ISP?</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign"> {{dataField.isISP === true ? "Yes" :
                                                "No"}}
                                            </p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="ONT">
                                        <mat-header-cell *matHeaderCellDef>Make of ONT</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">
                                                {{dataField.makeOfONT?dataField.makeOfONT:"-"}}
                                            </p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="FSAN">
                                        <mat-header-cell *matHeaderCellDef>FSAN/Device SL NO</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">
                                                {{dataField.fsanDeviceSerialNo?dataField.fsanDeviceSerialNo:"-"}} </p>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="CancellationDate">
                                        <mat-header-cell *matHeaderCellDef>Cancellation Date</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">
                                                {{dataField.cancellationDate==null?"-":dataField.cancellationDate| date
                                                :
                                                "dd-MMM-yyyy"}} </p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="RequiredServices">
                                        <mat-header-cell *matHeaderCellDef>Required Services On</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">
                                                {{dataField.requiredServicesOn==null?"-":dataField.requiredServicesOn|
                                                date
                                                :
                                                "dd-MMM-yyyy"}} </p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="BNumber">
                                        <mat-header-cell *matHeaderCellDef>B Number</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">
                                                {{dataField.bNumber?dataField?.bNumber:"-"}}
                                            </p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="Comments">
                                        <mat-header-cell *matHeaderCellDef>Comments</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">
                                                {{dataField.comments?dataField?.comments:"-"}}
                                            </p>
                                        </mat-cell>
                                    </ng-container>

                                    <mat-header-row *matHeaderRowDef="displayedColumns3; sticky:true"></mat-header-row>

                                    <mat-row *matRowDef="let row; columns: displayedColumns3;" matRipple>
                                    </mat-row>

                                </mat-table>
                                <div *ngIf="dataSource3.data.length == 0" class="no-data-message">
                                    <p>No data found</p>
                                </div>
                            </div>
                        </div>

                        <!-- </mat-tab> -->
                    </div>
                </div>





                <div class="container my-4" *ngIf="value.title=='cancel'">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Connection Details</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <!-- <mat-tab label="Connection Details"> -->
                        <form [formGroup]="form">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Product Name</mat-label>
                                        <input matInput maxlength="25" formControlName="aliasName" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Service Provider</mat-label>
                                        <input matInput maxlength="25" formControlName="serviceProvider" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Montly Fees</mat-label>
                                        <input matInput maxlength="25" formControlName="totalProductCost" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>
                                <div class="col-xl-6 mt-4">
                                    <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                        <mat-label>Connection Active From</mat-label>
                                        <input readonly matInput formControlName="connectionActivatedOnTs"
                                            autocomplete="off" placeholder="Select From Date"
                                            class="custom-input-border">
                                        <mat-datepicker-toggle matSuffix style="color:black;">
                                            <button mat-icon-button>
                                                <mat-icon>event</mat-icon>
                                            </button>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #startDatePicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-xl-6 mt-4">

                                    <mat-form-field appearance="fill" hideRequiredMarker
                                        [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                                        <mat-label>Address</mat-label>
                                        <textarea rows="4" matInput type="text" placeholder="Enter Query"
                                            formControlName="completeAddress" autocomplete="off" specialIsAlphaNumeric
                                            class="col-12"></textarea>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-xl-6 mt-4">

                                    <mat-form-field appearance="fill" hideRequiredMarker
                                        [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                                        <mat-label>comments</mat-label>
                                        <textarea rows="4" matInput type="text" placeholder="Enter Query"
                                            formControlName="comments" autocomplete="off" specialIsAlphaNumeric
                                            class="col-12"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-6 mt-4">
                                    <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                        <mat-label>Cancellation Date</mat-label>
                                        <input readonly matInput formControlName="requestedCancellationTs"
                                            autocomplete="off" placeholder="Select From Date"
                                            class="custom-input-border">
                                        <mat-datepicker-toggle matSuffix style="color:black;">
                                            <button mat-icon-button>
                                                <mat-icon>event</mat-icon>
                                            </button>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #startDatePicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Reason Type</mat-label>
                                        <input matInput maxlength="25" formControlName="reasontypeName" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>

                            </div>
                            <div class="row" *ngIf="form?.value?.returnDate">
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Router Return Date</mat-label>
                                        <input matInput maxlength="25" formControlName="returnDate" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>


                                <div class="col-sm-12 col-xl-6 mt-2">
                                    <mat-form-field appearance="fill" hideRequiredMarker
                                        [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                                        <mat-label>Router Return Address</mat-label>
                                        <textarea rows="3" matInput type="text" formControlName="returnAddress"
                                            autocomplete="off" specialIsAlphaNumeric class="col-12"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                        </form>

                        <!-- </mat-tab> -->
                    </div>
                </div>
                <div class="container my-4" *ngIf="form.value.terminationFee">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Recovery Fee Calculation</span>
                        </div>
                    </div>
                    <div class="card card_content" *ngIf="form.value.terminationFee">
                        <!-- <mat-tab label="Recovery Fee Calculation"> -->
                        <form [formGroup]="trinationfeeform">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>FTTX</mat-label>
                                        <input matInput maxlength="25" formControlName="fibreType" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Connected days total</mat-label>
                                        <input matInput maxlength="25" formControlName="daysUsed" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Remaining Contract days total</mat-label>
                                        <input matInput maxlength="25" formControlName="daysRemaining" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>VAT Amount</mat-label>
                                        <input matInput maxlength="25" formControlName="vatAmount" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12 col-md-6 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Total Amount</mat-label>
                                        <input matInput maxlength="25" formControlName="feeWithVat" class="col-10"
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>
                            </div>
                        </form>
                        <!-- </mat-tab> -->
                    </div>
                </div>

                <div class="container my-4" *ngIf="applicationDetails?.routerCustomerComments">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Comment Box</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <form [formGroup]="form">
                            <div class="col-sm-12 col-xl-12 mt-2">
                                <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'textArea-mat-field'"
                                    style="border-radius: 0 !important;">
                                    <mat-label>Comments/Notes</mat-label>
                                    <textarea rows="3" matInput type="text"
                                        placeholder="Please add anything you would like us to know?"
                                        formControlName="routerCustomerComments" autocomplete="off"
                                        specialIsAlphaNumeric class="col-12 pl-2"></textarea>
                                </mat-form-field>
                            </div>
                        </form>
                    </div>
                </div>


                <div class="container my-4" *ngIf="isdoc && sessionDataString.roleId!=7">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">File Details</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <!-- <mat-tab label="File Details"> -->

                        <div class="table-responsive mt-2 mb-4">
                            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                                <ng-container matColumnDef="Type">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Type">Type</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign"> {{dataField.documentTypeString}}</p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="Date">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Date">Date</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.uploadedDate}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="FileName">
                                    <mat-header-cell *matHeaderCellDef
                                        mat-sort-header="FileName">FileName</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.fileName}} </p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="action">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <div class="text-truncate text-center">

                                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;"
                                                class="fa fa-download" title="download"
                                                (click)="download(dataField.id)"></i>
                                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;"
                                                class="fa fa-edit ml-3" title="upload"
                                                *ngIf="value.title=='transfer'|| value.title=='fiber' || this.value.title == 'wirelessrain' || this.value.title == 'viewfiber' || this.value.title == 'view'"
                                                (click)="upload(dataField)"></i>
                                        </div>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                                </mat-row>
                            </mat-table>
                        </div>


                        <!-- </mat-tab> -->
                    </div>
                </div>

                <div class="container my-4"
                    *ngIf="value.title!='transfer'&& value.title!='fiber' && value.title != 'editapplication'&& value.title != 'fibereditapplication' && value.title != 'wirelessrain' && value.title != 'view' && value.title != 'viewfiber'">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Service Cancellation History</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <!-- <mat-tab label="Service Cancellation History"> -->

                        <div class="table-responsive mt-2 mb-4">
                            <mat-table #table [dataSource]="dataSource1" matSort matSortDirection="asc">

                                <ng-container matColumnDef="UpdatedOn">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="UpdatedOn">Updated
                                        On</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign"> {{dataField.updatedOnTs}}</p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="Status">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Status">Status</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.changeRequestStatusTypeName}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="DoneBy">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="DoneBy">Done
                                        By</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.updatedBy}} </p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="IPAddress">
                                    <mat-header-cell *matHeaderCellDef
                                        mat-sort-header="IPAddress">IPAddress</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.IPAddress}} </p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="RetentionAgentName">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="RetentionAgentName">
                                        Retention agent name
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.retentionAgentName}} </p>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns1; sticky:true"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: displayedColumns1;" matRipple>
                                </mat-row>
                            </mat-table>

                        </div>
                        <!-- </mat-tab> -->
                    </div>
                </div>


                <div class="container my-4" *ngIf="showLocationAddress">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar">Address Location List</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="row">
                            <h4>
                                Address : {{fulladdress}}
                            </h4>
                        </div>
                        <div class="table-responsive mt-4 mb-4">
                            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
                                <ng-container matColumnDef="Address">
                                    <mat-header-cell *matHeaderCellDef
                                        mat-sort-header="Address">Address</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign"> {{dataField.address}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="MDUUnitNumber">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="MDUUnitNumber">MDU Unit
                                        Number</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign"> {{dataField.mdu_unitno}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="MDUUnitName">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="MDUUnitName">MDU Unit
                                        Name</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign"> {{dataField.mdu_name}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="NetworkType">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="NetworkType">Network
                                        Type</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign"> {{dataField.networktype}}</p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="PremiseReferenceISP">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="PremiseReferenceISP">Premise
                                        Reference
                                        ISP</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.premise_ref_isp}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="ObjectID">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="ObjectID">Object
                                        ID</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.objectID}} </p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="Action">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <div class="text-truncate text-center">

                                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;"
                                                class="fa fa-pencil" title="Process Address"
                                                (click)="redirectPage(dataField.premise_ref_isp, dataField.objectID, dataField.address)"></i>

                                        </div>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns2; sticky:true"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: displayedColumns2;" matRipple>
                                </mat-row>
                            </mat-table>
                        </div>
                    </div>
                </div>

                <!-- application history -->
                <ng-container *ngIf="sessionDataString.roleId==7">
                    <div class="container mt-4">
                        <div class="row">
                            <div class="col-12 ">
                                <span class="title_header_bar2" style="border-radius: 5px;">Application History</span>
                            </div>
                        </div>
                        <div class="table-responsive mt-4 mb-4">
                            <mat-table #table [dataSource]="dataSource5" matSort matSortDirection="asc">

                                <ng-container matColumnDef="UpdatedOn">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="UpdatedOn">Updated
                                        On</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign"> {{dataField.updatedOnTs|date:'yyyy-MM-dd
                                            hh:mm a'}}</p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="Status">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Status">Status</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.applicationStatusTypeName}}
                                        </p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Notes">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Notes">Notes</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.notes}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="DoneBy">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="DoneBy">Done
                                        By</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.updatedBy}} </p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="IPAddress">
                                    <mat-header-cell *matHeaderCellDef
                                        mat-sort-header="IPAddress">IPAddress</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.ipAddress}} </p>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns5; sticky:true"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: displayedColumns5;" matRipple>
                                </mat-row>

                            </mat-table>
                            <div *ngIf="dataSource5.data.length == 0" class="no-data-message">
                                <p>No data found</p>
                            </div>
                        </div>
                    </div>

                    <!-- service change history-->
                    <div class="container mt-4" *ngIf="dataSource7.data.length != 0">
                        <div class="row">
                            <div class="col-12 ">
                                <span class="title_header_bar2" style="border-radius: 5px;">Service Change
                                    History</span>
                            </div>
                        </div>
                        <div class="table-responsive mt-4 mb-4">
                            <mat-table #table [dataSource]="dataSource7" matSort matSortDirection="asc">

                                <ng-container matColumnDef="ReferenceNumber">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="UpdatedOn">Reference
                                        Number</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign"> {{dataField.referenceNumber}}</p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="Status">
                                    <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.changeRequesStatusType}}
                                        </p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="OldProductId">
                                    <mat-header-cell *matHeaderCellDef>Old ProductId</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.oldProduct}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="NewProductId">
                                    <mat-header-cell *matHeaderCellDef>New ProductId</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.newProduct}} </p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="UpdatedOn">
                                    <mat-header-cell *matHeaderCellDef>Updated On</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.updatedDate|date:'yyyy-MM-dd hh:mm
                                            a'}} </p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="DoneBy">
                                    <mat-header-cell *matHeaderCellDef>Done By</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.updatedBy}} </p>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns7; sticky:true"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: displayedColumns7;" matRipple>
                                </mat-row>

                            </mat-table>
                        </div>
                    </div>


                    <div class="container mt-4">
                        <div class="row">
                            <div class="col-12 ">
                                <span class="title_header_bar2" style="border-radius: 5px;">Private Notes</span>
                            </div>
                        </div>

                        <div class="table-responsive mt-2 mb-4">
                            <mat-table #table [dataSource]="dataSource6" matSort matSortDirection="asc">

                                <ng-container matColumnDef="Notes">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Notes">Notes</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign"> {{dataField.notes.description}}</p>
                                    </mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="Status">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Status">Status</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.applicationStatusName}}
                                        </p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="CommentedOn">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="CommentedOn">Commented
                                        On</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.creationTs| date:'dd-MMM-yyyy
                                            HH:mm a'}}</p>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="Commentedby">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header="Commentedby">Commented
                                        by</mat-header-cell>
                                    <mat-cell *matCellDef="let dataField">
                                        <p class="text-truncate txtalign">{{dataField.notes.updatedBy}} </p>
                                    </mat-cell>
                                </ng-container>



                                <mat-header-row *matHeaderRowDef="displayedColumns6; sticky:true"></mat-header-row>

                                <mat-row *matRowDef="let row; columns: displayedColumns6;" matRipple>
                                </mat-row>

                            </mat-table>
                            <div *ngIf="dataSource6.data.length == 0" class="no-data-message">
                                <p>No data found</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <!-- </mat-tab-group> -->
                <!-- </div> -->
            </div>
        </div>
    </div>
</div>